module.exports = "/assets/site/images/foci.jpg?c2a06f6f54c713137198b53582b33aa8";